/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCarousel = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M2 2v13h20V2zm18 11H4V4h16zm-4 9h6v-6h-6zm2-4h2v2h-2zm-9 4h6v-6H9zm2-4h2v2h-2zm-9 4h6v-6H2zm2-4h2v2H4z"
      fill="currentcolor"
    />
  </Icon>
);
export { SvgCarousel as Carousel };
